


var dialogWidetList = {};
var focusedElBeforeOpen = null;

var lightboxDialog = null;
var mobileContactUsDialog = null;

//var lightboxAltText = "";


document.body.addEventListener('keydown', function(event) {
    var keyName = event.code;
    var KEY_ESC = 'Escape';//27;

    if (keyName ==  KEY_ESC ){
       
        jQuery('.dialog-widget').each( function(){
          
            displayValue = jQuery(this ).css('display');
            if ( displayValue != "none"){
                jQuery(this ).find('.dialog-close-button').trigger("click");
            }

        })
        
       
    }
});


jQuery(document).ready(function ($) {


    /***
     * 
     *  This check for button that opens elementor lightbox 
     * 
     */
     $('.elementor-open-lightbox .elementor-custom-embed-play').attr("aria-haspopup","dialog");
     $('.elementor-open-lightbox .elementor-custom-embed-play').on('click keypress',function(event){
        if(a11yClick(event)===true){
       
            if(event.type === 'keypress'){
                jQuery(this).trigger('click');
                return;
            }
            
            focusedElBeforeOpen = $(this);          

    
            if (lightboxDialog == null){
                checkForLightboxModal();
            } else{
                openLightboxModal();
            }       
        }
    });

    setMobileContactUsDialog();

    function setMobileContactUsDialog(){

        var navDialogEl = document.getElementById('contact-box');

        mobileContactUsDialog = new Dialog(navDialogEl)

        $('a.login-window').on('click keypress',function(event){

          
            if(a11yClick(event)===true){
       
                if(event.type === 'keypress'){
                    jQuery(this).trigger('click');
                    return;
                }

                focusedElBeforeOpen = $(this);
                mobileContactUsDialog.open();
                
            }

        })

        $('#contact-box a.close').on('click keypress',function(event){

            if(a11yClick(event)===true){
       
                if(event.type === 'keypress'){
                    jQuery(this).trigger('click');
                    return;
                }
            }

            mobileContactUsDialog.close();

        });
        
     }

     /**
      * 
      *  It take time to open the elementor lightbox for the first time so we try every 10ms to see if it ready
      * 
      */
    function checkForLightboxModal(count){

        //console.log ("checkForLightboxModal was called "+count );

        if (count == undefined || count == null){
            count=0;
        } else{
            count++
            if (count > 10){
                console.error("Somthing is wrong - checkForLightboxModal is in infinate loop! ")
                return;
            }
        }

        var pojDialog = $(".elementor-lightbox");

        if(pojDialog.length){
           setLightboxModal();
        }else{
           
            setTimeout ( checkForLightboxModal , 10, count)
        }
    }

    function setLightboxModal(){           
      
        var navDialogEl = document.querySelector('.elementor-lightbox');
        lightboxDialog = new Dialog(navDialogEl);

             
        $('.elementor-lightbox').attr("aria-modal","true");
        $('.elementor-lightbox').attr("role","dialog");
        $('.elementor-lightbox .dialog-close-button').on('click', closeLightboxModal);
        $('.elementor-lightbox .dialog-message').on('click', closeLightboxModal);


        openLightboxModal();
    }

    function openLightboxModal(){   
        
        setTimeout(function(){
            
            $('.elementor-lightbox .dialog-lightbox-message').append('<div classs="sr-only" tabindex="0">סוף חלון פופ-אפ</div>');
            /*

            $('.elementor-lightbox header i[role="switch"]').attr('tabindex',0);
            $('.elementor-lightbox header i[role="switch"]').attr('role','button');*/
            lightboxDialog.open();
        
        
        },250);
    }

    function closeLightboxModal(){

        lightboxDialog.close();
    }


   

    function setDialogWidget(selector1,selector2){


        var widgetDialogEl = document.querySelector(selector1,selector2);   
       
        return new Dialog(widgetDialogEl);
       
    
    }

    function dialogExits(id){
        
        var dialog = 'popup'+id  in  dialogWidetList;

        if (dialog == undefined || dialog == null || !dialog){
           
            return false;
        }

        return true;

    }

});



function Dialog(dialogEl) {

  	this.dialogEl = dialogEl;
	//this.overlayEl = overlayEl;
	this.focusedElBeforeOpen;

	//var focusableEls = this.dialogEl.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
	this.focusableEls; // = Array.prototype.slice.call(focusableEls);

	this.firstFocusableEl; // = this.focusableEls[0];
	this.lastFocusableEl; // = this.focusableEls[ this.focusableEls.length - 1 ];

    this.hasiFrame=false;

	//this.close(); // Reset
}


Dialog.prototype.setFocusableEls = function() {

    var focusableEls = this.dialogEl.querySelectorAll('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]','iframe');
	this.focusableEls = Array.prototype.slice.call(focusableEls);

	this.firstFocusableEl = this.focusableEls[0];
	this.lastFocusableEl = this.focusableEls[ this.focusableEls.length - 1 ];

    //console.log("setFocusableEls: focusableEls lenght "+focusableEls.length);

}

Dialog.prototype.open = function() {

  	var Dialog = this;

    
    this.setFocusableEls();

	//this.dialogEl.removeAttribute('aria-hidden');
	//this.overlayEl.removeAttribute('aria-hidden');

	this.focusedElBeforeOpen = document.activeElement;

	this.dialogEl.addEventListener('keydown', function(e) {
		Dialog._handleKeyDown(e);
	});
    /*
	this.overlayEl.addEventListener('click', function() {
		Dialog.close();
	});
    */
  
	this.firstFocusableEl.focus();
};

Dialog.prototype.close = function() {

	//this.dialogEl.setAttribute('aria-hidden', true);
	//this.overlayEl.setAttribute('aria-hidden', true);
  
    if(focusedElBeforeOpen){
        focusedElBeforeOpen.focus();
    } else if ( this.focusedElBeforeOpen ) {
		this.focusedElBeforeOpen.focus();
	} else {
       document.querySelector('body').focus();
       
    }
};


Dialog.prototype._handleKeyDown = function(e) {

	var Dialog = this;
	var KEY_TAB = 9;
	var KEY_ESC = 27;

	function handleBackwardTab() {
		if ( document.activeElement === Dialog.firstFocusableEl ) {
			e.preventDefault();
			Dialog.lastFocusableEl.focus();
		}
	}
	function handleForwardTab() {

       

		if ( document.activeElement === Dialog.lastFocusableEl ) {

			e.preventDefault();
			Dialog.firstFocusableEl.focus();
		}
	}

	switch(e.keyCode) {
	case KEY_TAB:
		if ( Dialog.focusableEls.length === 1 ) {
			e.preventDefault();
			break;
		} 
		if ( e.shiftKey ) {
			handleBackwardTab();
		} else {
			handleForwardTab();
		}
		break;
	case KEY_ESC:
		Dialog.close();
		break;
	default:
		break;
	}


};



Dialog.prototype.setCloseButton = function (closeDialogSel){
    var Dialog = this;
    var closeDialogEls = document.querySelectorAll(closeDialogSel);
	for ( var i = 0; i < closeDialogEls.length; i++ ) {
		closeDialogEls[i].addEventListener('click', function() {
			Dialog.close();
		});
	}
}

Dialog.prototype.addEventListeners = function(openDialogSel, closeDialogSel) {

	var Dialog = this;

    var openDialogEls = document.querySelectorAll(openDialogSel);
  //  if ( openDialogEls != null && openDialogEls != undefined  ){
        for ( var i = 0; i < openDialogEls.length; i++ ) {
            openDialogEls[i].addEventListener('click', function() { 
                Dialog.open();
            });
        } 
    //}
	

	var closeDialogEls = document.querySelectorAll(closeDialogSel);
	for ( var i = 0; i < closeDialogEls.length; i++ ) {
		closeDialogEls[i].addEventListener('click', function() {
			Dialog.close();
		});
	}

};